import React, { useState, useCallback, useContext } from "react";
import { Modal } from "react-bootstrap";

import AuthenticationContext from "../context/Authentication/AuthenticationContext";

import CustomButton, {
  CustomButtonProps,
} from "../components/kits/custom-button/CustomButton";

import "../components/login/login.scss";

import EnterPhoneNumber from "../components/login/EnterPhoneNumber";
import VerifyCode from "../components/login/VerifyCode";
import { InputWithValidation } from "../types/input";

enum Steps {
  EnterPhoneNumber,
  VerifyCode,
}

interface InjectedProps extends CustomButtonProps {
  prevMobile?: string;
}

const WithLogin: React.FC<InjectedProps> = ({
  prevMobile,
  onClick,
  ...props
}) => {
  const { login: loginUser } = useContext(AuthenticationContext);

  const [mobile, setMobile] = useState<InputWithValidation<string>>({
    checked: false,
    validate: true,
    value: "",
  });
  const [hashCode, setHashCode] = useState<string>("");
  const [step, setStep] = useState<Steps>(Steps.EnterPhoneNumber);
  const [show, setShow] = useState<boolean>(false);

  const changeStep = (step: Steps) => {
    setStep(step);
  };

  const resetMobile = useCallback(() => {
    setMobile({
      checked: false,
      validate: true,
      value: prevMobile || "",
    });
  }, [prevMobile]);

  const openModal: React.MouseEventHandler<HTMLButtonElement> = useCallback(
    (event) => {
      resetMobile();
      setShow(true);
      setStep(Steps.EnterPhoneNumber);
      onClick && onClick(event);
    },
    [onClick, resetMobile]
  );

  return (
    <div>
      <CustomButton onClick={openModal} {...props} />

      <Modal
        className="custom-modal"
        show={show}
        onHide={() => setShow(false)}
        centered
      >
        <Modal.Body style={{ padding: 0, margin: 0 }}>
          <div className="login-modal">
            {step === Steps.EnterPhoneNumber ? (
              <EnterPhoneNumber
                mobile={mobile}
                setMobile={setMobile}
                setHashCode={setHashCode}
                backward={() => {
                  setShow(false);
                }}
                forward={() => changeStep(Steps.VerifyCode)}
              />
            ) : (
              <VerifyCode
                backward={() => {
                  changeStep(Steps.EnterPhoneNumber);
                }}
                changeMobile={() => changeStep(Steps.EnterPhoneNumber)}
                forward={(user) => {
                  loginUser(user);
                  setShow(false);
                }}
                mobile={mobile.value}
                hashcode={hashCode}
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default WithLogin;
